module.exports = __webpack_public_path__ + "img/aboutus.194a0ea1.png";